import { render, staticRenderFns } from "./NewBankModal.vue?vue&type=template&id=cb201d84&scoped=true"
import script from "./NewBankModal.vue?vue&type=script&lang=js"
export * from "./NewBankModal.vue?vue&type=script&lang=js"
import style0 from "./NewBankModal.vue?vue&type=style&index=0&id=cb201d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb201d84",
  null
  
)

export default component.exports